module.exports = __webpack_public_path__ + "static/media/platform.275cfb24.svg";